import { Box, TextNew } from '@jfs/ui-new'
import React, { FC } from 'react'
import styles from './styles'
import { WeekDayProps } from './types'

const weekDays = [
  { key: 1, value: 'SUN' },
  { key: 2, value: 'MON' },
  { key: 3, value: 'TUE' },
  { key: 4, value: 'WED' },
  { key: 5, value: 'THU' },
  { key: 6, value: 'FRI' },
  { key: 7, value: 'SAT' },
]
const WeekDayView: FC<WeekDayProps> = ({ type }: WeekDayProps) => {
  return (
    <Box {...styles[type].WeekDayContainer} pl={12}>
      {weekDays.map((item) => (
        <Box f={1}>
          <TextNew {...styles[type].WeekDayTextStyle} key={item.key}>
            {item.value}
          </TextNew>
        </Box>
      ))}
    </Box>
  )
}

export default WeekDayView
